import React from 'react'

const StandardThermal = (props) => {
  const { logo, helpline, website, delivery, declare } = props?.data
  return (
    <div className="booking-thermal">
      <div className="ticket-body">
        {!logo && (
          <div className="logo-container">
            <img
              style={{ filter: 'grayscale(100%)' }}
              src="https://mavenconnect.biz/maventech-logo.png"
              alt="logo"
              width="40px"
              height="40px"
            />
          </div>
        )}
        {}

        <h1>_Maven Tech Services Pvt. Ltd.</h1>
        <div className="divider-h"></div>
        <h2>Maven Operations Ahmedabad</h2>
        {!helpline && (
          <h3>
            Helpline No. : <span>+91 9876543211</span>
          </h3>
        )}
        {!website && (
          <h3>
            Website : <span>www.Mavenopsahmedabad.com</span>
          </h3>
        )}

        <div className="divider-h"></div>
        <h3>
          <span>Wed,May27,2024</span> <span>19:27</span>
        </h3>
        <div className="divider-h"> </div>
        <h2>
          <span>Ahmedabad</span> To <span>Bangalore</span>
        </h2>
        <div className="divider-h"></div>
        <div className="data-row">
          <div className="data-heading">Payment Type</div>
          <div className="data-value">To Pay</div>
        </div>
        <div className="data-row">
          <div className="data-heading">Way Bill No.(LR No.)</div>
          <div className="data-value">MAHD/23-24/72</div>
        </div>
        <div className="data-row">
          <div className="data-heading">Sender Name</div>
          <div className="data-value">Krishna</div>
        </div>
        {!delivery && (
          <div className="data-row">
            <div className="data-heading">Sender Mobile No</div>
            <div className="data-value">9033090802</div>
          </div>
        )}

        <div className="data-row">
          <div className="data-heading">Receiver Name</div>
          <div className="data-value">Prateek</div>
        </div>
        {!delivery && (
          <div className="data-row">
            <div className="data-heading">Receiver Mobile No.</div>
            <div className="data-value">9033090802</div>
          </div>
        )}
        <div className="data-row">
          <div className="data-heading">Units</div>
          <div className="data-value">3</div>
        </div>
        <div className="data-row">
          <div className="data-heading">Consignment Type</div>
          <div className="data-value">Multiple</div>
        </div>
        <div className="data-row">
          <div className="data-heading">Actual Weight</div>
          <div className="data-value">25.0</div>
        </div>
        <div className="data-row">
          <div className="data-heading">Charged Weight </div>
          <div className="data-value">25.0,0.0</div>
        </div>
        <div className="data-row">
          <div className="data-heading">Rate</div>
          <div className="data-value">20.0,200.0</div>
        </div>
        <div className="data-row">
          <div className="data-heading">Freight</div>
          <div className="data-value">500.0,600.0</div>
        </div>
        {!delivery && (
          <div className="data-row">
            <div className="data-heading">Other Charges</div>
            <div className="data-value">112.0</div>
          </div>
        )}
        <div className="data-row">
          <div className="data-heading">Total Amount</div>
          <div className="data-value">1212.0</div>
        </div>

        {delivery ? (
          <>
            <div className="data-row">
              <div className="data-heading">Delivery Charges</div>
              <div className="data-value">0.00</div>
            </div>
            <div className="data-row">
              <div className="data-heading">otal Outstanding</div>
              <div className="data-value">495.00</div>
            </div>
            <div className="data-row">
              <div className="data-heading">Received By</div>
              <div className="data-value">Krishna</div>
            </div>
            <div className="data-row">
              <div className="data-heading">Receiver Mobile No.</div>
              <div className="data-value">9033090802</div>
            </div>
          </>
        ) : (
          ''
        )}
        <div className="data-row">
          <div className="data-heading">{`${delivery ? 'Delivery' : 'Booking'}`} Date & Time</div>
          <div className="data-value">16-Jan-24,12:08 PM</div>
        </div>
        <div className="data-row">
          <div className="data-heading">{`${delivery ? 'Delivered' : 'Booked'}`} By</div>
          <div className="data-value"> Krishna Pandey</div>
        </div>
        <div className="divider-h"></div>
        <div className="left-heading">Signature</div>
        <div className="signature-box"></div>
        <div className="divider-h"></div>
        <div className="left-heading">Rules & Regulations</div>
        <p>
          1. Parcel / Luggage / Covers are carried at owner s risk. 2. In case the parcels are loss or damaged on transit the Company will
          not take any liabilities on it. 3. Contraband articles are not permitted to be carried in the vehicles. The Parcel / Luggage /
          Cover owners or their agents will bear sole responsibility in case any objectionable / contraband goods are found in the packages
          on checked by octroi, excise or any other authority . Octroi will be levied on goods entering Mumbai. 4. We do not hold any
          responsibility on the late arrival of Parcel / Cover / Luggage. 5. Any enquiry regarding this parcel should be made within a week
          if not the company is not responsible. 6. In case the luggage is not collected within 7 days demurrage will be charged 10% on the
          Total Bill. 7. Above 20 Kgs service charges will be charged @ 10% of the Total Bill. 8. Cash will not be accepted as parcel. If
          without our knowledge cash is sent company does not take any responsibility for misplacement or loss
        </p>

        {!declare && (
          <>
            <div className="divider-h"></div>
            <div className="left-heading">Declaration</div>
            <p>
              We hereby agree to the terms and conditions set out on the above of this consignor copy and declare that the contents on this
              way bill are true and correct. The Topay freight has my/our consent and will be paid by the consignee along with other charges
              and delivery charges as per actual at the time of delivery
            </p>
          </>
        )}

        <div className="divider-h"></div>
        <div>We appreciate your business.</div>
      </div>
    </div>
  )
}

export default StandardThermal
